import { render, staticRenderFns } from "./date_field.vue?vue&type=template&id=5ddfc55a&scoped=true&"
import script from "./date_field.vue?vue&type=script&lang=js&"
export * from "./date_field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddfc55a",
  null
  
)

export default component.exports